import React from 'react';
import './LessonBottomBar.css';

const LessonBottomBar = ({
  primaryButtonLabel,
  secondaryButtonLabel,
  onPrimaryClick,
  onSecondaryClick,
  onPrevious,
  onNext,
  canGoPrevious,
  canGoNext,
  primaryDisabled = false,
  secondaryButtonDisabled = false,
  showNavigation = true
}) => {
  return (
    <div className="lesson-bottom-bar">
      <div className="bottom-bar-content">
        {showNavigation && (
          <button
            className="nav-button prev-button"
            onClick={onPrevious}
            disabled={!canGoPrevious}
          >
            ← Forrige
          </button>
        )}

        <div className="action-buttons">
          {/* {secondaryButtonLabel && (
            <button
              className="secondary-button"
              onClick={onSecondaryClick}
              disabled={secondaryButtonDisabled}
            >
              {secondaryButtonDisabled ? 'Laster...' : secondaryButtonLabel}
            </button>
          )} */}
          {primaryButtonLabel && (
            <button
              className="primary-button"
              onClick={onPrimaryClick}
              disabled={primaryDisabled}
            >
              {primaryButtonLabel}
            </button>
          )}
        </div>

        {showNavigation && (
          <button
            className="nav-button next-button"
            onClick={onNext}
            disabled={!canGoNext}
          >
            Neste →
          </button>
        )}
      </div>
    </div>
  );
};

export default LessonBottomBar;
